export default {
  /**
   * Prepare form data for use in the application,
   * .url should never be mutated, that's why we have .activeUrl
   */
  forms (state, getters, rootState) {
    const forms = state.forms
    for (let key in forms) {
      const form = forms[key]
      let urlOperator = '?' // this will be changed to '&' after first iteration
      let urlQuery = ''
      // Check if there are any parameters to be added to the url
      if (form.urlParameters) {
        for (let parameterKey in form.urlParameters) {
          const urlParameter = form.urlParameters[parameterKey]
          const variable = urlParameter.variable
          const dynamicValue = urlParameter.dynamicValue
          let value = urlParameter.value // the value to be added in url parameter
          // If this url parameter is a dynamic value, generate value and overwrite value
          if (dynamicValue) {
            switch (dynamicValue) {
              case 'email':
                value = rootState.user.email
                break
              default:
                console.error('Unsupported dynamic value "' + dynamicValue + '"')
            }
          }
          // build url
          urlQuery += urlOperator + variable + '=' + value // this is the url to be used in an actual link
          urlOperator = '&'
        }
        form.activeUrl = form.url + urlQuery // append the query to the base url
      } else { form.activeUrl = form.url }
    }
    return forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tools/forms/getters.js